import { setHasDiscoveredSpaceMentions } from '#pplx/frontend/apps/ask/browser-state/cookieManager.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
// Single-file event: defined here at its only call site rather than in a shared package.
const spaceMentionedInQueryEvent = {
    event: 'space mentioned in query',
    data: {},
};
export const useSpaceAnalytics = () => {
    const { track } = useInstrumentation();
    const handleSubmitQueryWithMention = useCallback(async () => {
        track(spaceMentionedInQueryEvent);
        setHasDiscoveredSpaceMentions();
    }, [track]);
    return useMemo(() => ({ handleSubmitQueryWithMention }), [handleSubmitQueryWithMention]);
};
//# sourceMappingURL=useSpaceAnalytics.js.map